module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/icn-report-62cd8f31ca5d9947e69ca9bc8e35fadb.svg";